'use client';

import Script from 'next/script';
import { JSX } from 'react';

export const BASIS_PIXEL_ID = '4c839d4ce7472536';

declare global {
    interface Window {
        cntrUpTag?: { track: (dataVariableName: 'cntrData', pixelId: string) => void };
    }
}

/**
 * up.js sends Basis the full page URL, including any token or email in the path or query string.
 */
export function BasisUniversalPixel(): JSX.Element {
    return (
        <Script
            id="basis-universal-pixel"
            src="https://cdn01.basis.net/assets/up.js?um=1"
            strategy="afterInteractive"
            onLoad={() => window.cntrUpTag?.track('cntrData', BASIS_PIXEL_ID)}
        />
    );
}
